/* eslint-disable */
import React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import PropTypes from 'prop-types'

import { noop } from '../../utils/general'

const ButtonWithLoader = ({
  loading,
  onClick,
  disabled,
  label,
  className,
  sx,
}) => (
  <Button
    className={className}
    variant="contained"
    type="submit"
    onClick={onClick}
    disabled={loading || disabled}
    disableElevation
    startIcon={loading && <CircularProgress size={20} color="inherit" />}
    sx={sx}
  >
    {label}
  </Button>
  )

ButtonWithLoader.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
}

ButtonWithLoader.defaultProps = {
  loading: false,
  disabled: false,
  onClick: noop,
  label: '',
  className: 'primary-btn',
}

export default ButtonWithLoader
